import React, { useEffect, useState } from "react";
import PageBanner from "../../components/PageBanner";
import DocumentService from "../../services/document";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function Document() {
  let [documentData, setDocumentData] = useState(null);
  let [documentBanner, setDocumentBanner] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDocumentData();
    getDocumentBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  const getDocumentData = async () => {
    try {
      let res = await DocumentService.getDocument();
      setDocumentData(res);
    } catch {
      console.error();
    }
  };

  function openFile(data) {
    if (data.file.data) {
      window.open(data.file.data[0].attributes.url);
    }
    // else {
    //   window.open(data.link.href, "_blank");
    // }
  }

  const getDocumentBanner = async () => {
    try {
      let res = await BannerService.getBanner(7);
      setDocumentBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Document", href: "/document" }];

  return (
    <div id="resource" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"เอกสารดาวน์โหลด"}
        text_en={"Document"}
        banner={documentBanner.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-[28px] xl:text-[32px] text-left">
              {lang === "th" ? "เอกสารดาวน์โหลด" : "Documents"}
            </h1>

            <div className="flex gap-[40px] mt-[30px]">
              <div className="flex flex-col gap-[10px]">
                {documentData &&
                  documentData.map((item, i) => (
                    <h1 key={i} className="text-left text-[28px] font-medium">
                      {lang === "th"
                        ? item.name.detail_TH
                        : item.name.detail_EN}
                    </h1>
                  ))}
              </div>

              <div className="flex flex-col gap-[45px] border-darkGray border-l-[1px]">
                {documentData &&
                  documentData.map((item, i) => (
                    <div key={i} className="flex flex-col gap-[24px] pl-[50px]">
                      <h1 className="text-[28px] font-medium text-left">
                        {lang === "th"
                          ? item.name.detail_TH
                          : item.name.detail_EN}
                      </h1>

                      {item.document &&
                        item.document.map((item, i) => (
                          <div
                            key={i}
                            onClick={() => openFile(item)}
                            className="flex gap-[25px] items-center"
                          >
                            <div className="w-[28px] h-[28px] rounded-full bg-lightGray" />
                            <h1 className="text-[24px] font-medium cursor-pointer">
                              {lang === "th"
                                ? item.documentName.detail_TH
                                : item.documentName.detail_EN}
                            </h1>
                          </div>
                        ))}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
